import axios from "axios";
import { API_CONFIG, API_URL } from "./apiURL";

export async function getSearchResult(reportType,formData) {
  // console.log("Inside API call for getSearchResult for : " + reportType);
  let searchResult = null;
  await axios
    .post(API_URL + "getSearchResult/" + reportType, formData, API_CONFIG)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });

  return searchResult;
}

export async function getCdeDetails(reportType, crfId, diseaseId){
  // console.log("Inside API call for getCdeDetails for : " + crfId);
  let searchResult = null;

  let url = API_URL + "getSearchResult/CdeDetails/" + reportType + "/";

  await axios
    .post(url, { crfId, diseaseId }, API_CONFIG)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

    return searchResult;
}

export async function getCrfListing(formData) {
  // console.log("Inside API call for getCrfListing");
  let searchResult = null;

  await axios
    .post(API_URL + 'getSearchResult/CrfListing', formData, API_CONFIG)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

  return searchResult;
}

export async function getNocReport(crfId){
  // console.log("Inside API call for getNocReport for : " + crfId);
  let searchResult = null;
  await axios
    .get(API_URL + "getSearchResult/NocReport/" + crfId, API_CONFIG)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

    return searchResult;
}

export async function getRoster(diseaseId){
  // console.log("Inside API call for getRoster for : " + diseaseId);
  let searchResult = null;
  await axios
    .get(API_URL + "getSearchResult/Roster/" + diseaseId, API_CONFIG)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

    return searchResult;
}

export async function getGlossary(){
  // console.log("Inside API call for getGlossary");
  let searchResult = null;
  await axios
    .get(API_URL + "getSearchResult/Glossary/", API_CONFIG)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

    return searchResult;
}